// File: typescript/apps/front-end/src/main/react/Dialog/InviteUserToGroupsDialogLazy.ts
//
// Lazy delegate for the person-first group picker's imperative opener.
//
// `UserButtons` is eager chrome — it renders on the profile header, user cards, the home discovery
// rail, group member rows and join-request rows — so a static import of the dialog would pull the
// picker, its tabs and its candidate types onto the startup graph every page has to parse (rule 27).
// Routed through `importChunkWithRetryAndReload` rather than a bare `import()` so a stale or failed
// chunk fetch retries and reloads instead of silently doing nothing (rule 26).
//
// Drop-in replacement for `import { showInviteUserToGroupsDialog } from ".../InviteUserToGroupsDialog"`.

import type { Localizer } from "@/main/react/Types";
import { importChunkWithRetryAndReload } from "@/lib/lazyWithRetry";

export function showInviteUserToGroupsDialog(username: string, localizer: Localizer) {
    void importChunkWithRetryAndReload(
        () => import("@/main/react/Dialog/InviteUserToGroupsDialog").then((m) => ({ default: m.showInviteUserToGroupsDialog })),
        "invite-user-to-groups-dialog",
    ).then((m) => m.default(username, localizer));
}
